// extracted by mini-css-extract-plugin
export default {"errorModalBody":"index-module__errorModalBody___GBWmG","errorModalMessage":"index-module__errorModalMessage___I0QMo"};